import { RootState } from '../../types';

export const all = (state: RootState) => state.finance.withdrawalRequests;
export const listId = (_state: RootState, id: string) => id;
export const lists = (state: RootState) => all(state).lists;
export const listById = (state: RootState, id) => all(state).lists[id] || {};
export const loading = (state: RootState) => all(state).loading;
export const error = (state: RootState) => all(state).error;
